import { useEffect, useState } from "react";
import supabase from "../config/supabaseConfig";
import { City, Location } from "../types/locationType";

const useFetchAllLocations = () => {
  const [states, setStates] = useState<Location[]>([]);
  const [cities, setCities] = useState<City[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch locations
        const [
          { data: statesData, error: statesError },
          { data: citiesData, error: citiesError },
        ] = await Promise.all([
          supabase.from("states").select("*"),
          supabase.from("cities").select("*, states(name)"),
        ]);
        
        if (statesError || citiesError) throw new Error("Échec de la récupération des données");        // Fetch ad counts for states
        const { data: stateAdCounts, error: stateCountError } = await supabase.rpc(
          'count_ads_by_state'
        );

        // Fetch ad counts for cities
        const { data: cityAdCounts, error: cityCountError } = await supabase.rpc(
          'count_ads_by_city'
        );

        if (stateCountError || cityCountError) {
          console.error("Error fetching ad counts:", stateCountError || cityCountError);
        }        // Create map of counts for easier lookup
        const stateCountMap = new Map<string, number>();
        const cityCountMap = new Map<string, number>();

        stateAdCounts?.forEach((count: {state_id: string, count: number}) => 
          stateCountMap.set(count.state_id, count.count)
        );
        cityAdCounts?.forEach((count: {city_id: string, count: number}) => 
          cityCountMap.set(count.city_id, count.count)
        );

        // Add counts to states
        const statesWithCounts = (statesData || []).map(state => ({
          ...state,
          adCount: stateCountMap.get(state.id) || 0
        }));

        // Add counts to cities
        const citiesWithCounts = (citiesData || []).map(city => ({
          ...city,
          parentLocationName: city.states.name,
          adCount: cityCountMap.get(city.id) || 0
        }));

        setStates(statesWithCounts);
        setCities(citiesWithCounts);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return {
    states,
    cities,
    loading,
  };
};

export default useFetchAllLocations;
